
import Login from '../pages/login/NewThemeLogin';
import LanguageSelection from "../pages/language/NewThemeLanguages";
import Disclaimerpage from '../pages/template/disclaimerpage';
import NewLoginPage from "../pages/template/newLoginPage";
import NewLoginPageSec from "../pages/template/newLoginPageSec";
import NewLoginPageDesc from "../pages/template/newLoginPageDesc";
import NewSelectLanguagePage from "../pages/template/newSelectLanguagePage";
import NewHomePage from "../pages/template/newHomePage";
import EnterToken from '../pages/mfa/enterToken';
import GeneratePin from '../pages/mfa/generatePin';
// import EnterPin from '../pages/mfa/enterPin';
import CheckPin from '../pages/mfa/pinCheck';

const routes = [
    {
      path: "/login",
      name: "Login",
      displayName: "Login",
      component: Login
    },
    {
      path: "/selectlanguage",
      name: "selectlanguage",
      displayName: "selectlanguage",
      component: LanguageSelection,
    },
    {
      path: "/disclaimerpage",
      name: "disclaimerpage",
      displayName: "disclaimerpage",
      component: Disclaimerpage,
    },
    {
      path: "/enterToken",
      name: "enterToken",
      displayName: "enterToken",
      component: EnterToken,
    },
    {
      path: "/generatePin",
      name: "generatePin",
      displayName: "generatePin",
      component: GeneratePin,
    },
    // {
    //   path: "/enterPin",
    //   name: "enterPin",
    //   displayName: "enterPin",
    //   component:EnterPin,
    // },
    {
      path: "/checkPin",
      name: "checkPin",
      displayName: "checkPin",
      component:CheckPin,
    },
    {
      path: "/template/newLoginPage",
      name: "newLoginPage",
      displayName: "newLoginPage",
      component: NewLoginPage,
    },
    {
      path: "/template/newLoginPageSec",
      name: "newLoginPageSec",
      displayName: "newLoginPageSec",
      component: NewLoginPageSec,
    },
    {
      path: "/template/newLoginPageDesc",
      name: "newLoginPageDesc",
      displayName: "newLoginPageDesc",
      component: NewLoginPageDesc,
    },
    {
      path: "/template/newSelectLanguagePage",
      name: "newSelectLanguagePage",
      displayName: "newSelectLanguagePage",
      component: NewSelectLanguagePage,
    },
    {
      path: "/template/newhomepage",
      name: "newHomePage",
      displayName: "newHomePage",
      component: NewHomePage,
    },
    {
      redirect: true, 
       path: "/", 
       to: "/login", 
      // name: "Login" 

      //default: "/",
      name: "Login",
      displayName: "Login",
      component: Login,
    }
    
];

export default routes;